import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class EqualizeBehavior extends AbstractDataAttributeBehaviour {
    attrNames = {
        'container': 'data-equalize',
    };

    getContainerSelector() {
        return '[' + this.attrNames.container + ']';
    }

    equalizeItems(items){
        let height = 0;

        items.forEach( el => {
            //remove height so calcualted height is not based on pre-exsisitng instance of equalize
            el.style.removeProperty('height');
        } );

        items.forEach( el => {
            //remove height so calcualted height is not based on pre-exsisitng instance of equalize
            el.style.removeProperty('height');
            let elementHeight = parseInt(el.offsetHeight);
            if( elementHeight > height ) height = elementHeight;
        } );

        if(height > 0) {
            items.forEach( el => {
                el.style.height = `${height}px`
            } );
        }
    }

    initContainer(container)
    {
        let querySelector = container.getAttribute( this.attrNames.container );
        this.equalizeContainer(container, querySelector)

        // Subscribe to the carousel init event so we can equalise the height of carousel items.
        window.app.eventManager.subscribe('carousel.init', () => {
            this.equalizeContainer(container, querySelector)
        })

        setTimeout(() => {
            this.equalizeContainer(container, querySelector);
        }, 10);

        window.addEventListener('resize', () => { this.equalizeContainer(container, querySelector) } );


    }
    equalizeContainer(container, querySelector, log) {
        let items = container.querySelectorAll(querySelector);
        this.equalizeItems(items);
    }

}
